import { render, staticRenderFns } from "./CardWrapper.vue?vue&type=template&id=513d6fae&scoped=true&"
import script from "./CardWrapper.vue?vue&type=script&lang=js&"
export * from "./CardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CardWrapper.vue?vue&type=style&index=0&id=513d6fae&scoped=true&lang=css&"
import style1 from "./CardWrapper.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513d6fae",
  null
  
)

export default component.exports